<template>
  <div>
    <div ref="modalRef" v-bind="$attrs">
      <slot />
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  inheritAttrs: false,
});
</script>

<style></style>
